import { render, staticRenderFns } from "./SupplierStocksSumUpComponent.vue?vue&type=template&id=494a949b&"
import script from "./SupplierStocksSumUpComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStocksSumUpComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports